exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".WriteReview-root-xk6QJ {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.WriteReview-container-hxEqx {\n  margin: 5px auto;\n  padding: 0 0 40px;\n  margin-top: 30px;\n  max-width: var(--max-content-width);\n}", ""]);

// exports
exports.locals = {
	"root": "WriteReview-root-xk6QJ",
	"container": "WriteReview-container-hxEqx"
};